import { useState } from "react";
import PropTypes from "prop-types";
import capitalize from "capitalize";
import Modal from "@shared/v2/Modal";
import { UserSolidV6 } from "@shared/v2/Icomoon";
import BaseEvent from "./BaseEvent";

const TimelineLeadCreateEvent = ({ event, event: { timeline_fields: timelineFields } }) => {
  const [showModal, setShowModal] = useState(false);

  const descriptions = [];

  Object.keys(timelineFields).forEach((key) => {
    if (["name", "full name"].includes(key)) return;
    const titleizedKey = key
      .split("_")
      .map((element) => capitalize(element))
      .join(" ");
    descriptions.push(`${titleizedKey}: ${timelineFields[key]}`);
  });

  const details = descriptions.map((description) => <div key={description}>{description}</div>);

  return (
    <BaseEvent
      title="Failed to create lead"
      icon={<UserSolidV6 />}
      interactedAt={event.interacted_at_absolute}
      onClick={() => setShowModal(true)}
    >
      {details}
      <Modal
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[480px] tw-w-full tw-max-h-[90vh] tw-flex tw-flex-col tw-gap-[32px]"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header title="Failed to Create Lead" closeButton />
        <Modal.Body>
          <div className="tw-font-semibold">Details:</div>
          {details}
        </Modal.Body>
      </Modal>
    </BaseEvent>
  );
};

TimelineLeadCreateEvent.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default TimelineLeadCreateEvent;
